/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swift_Steep_Leopard_PatInputs */

const fr_swift_steep_leopard_pat = /** @type {(inputs: Swift_Steep_Leopard_PatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements`)
};

/**

* @param {Swift_Steep_Leopard_PatInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const swift_steep_leopard_pat = /** @type {((inputs?: Swift_Steep_Leopard_PatInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swift_Steep_Leopard_PatInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_swift_steep_leopard_pat(inputs)
});